import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FlexView, Col, Text } from '@cuemath/comps';

import COLORS from 'constants/colors';

export const MenuText = styled(Text)`
  font-style: normal;
  font-weight: ${({ selected }) => (selected ? 500 : 'normal')};
  font-size: 16px;
  line-height: 24px;
`;

export const MenuWrapper = styled(Col)`
  flex-direction: column;
  background-color: ${({ hovered }) => (hovered ? COLORS.CLOUD : 'inherit')};
`;

export const MenuCol = styled(FlexView)`
  height: 40px;
  justify-content: center;
  padding: 0px 16px;
  cursor: pointer;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
